import handleUserActionSignOut from "utils/handle-user-action/sign-out";

const handleError = ({ code }) => {
  if (code === 401) {
    handleUserActionSignOut();
    window.navigation.navigate("/authentication/sign-in");
  }
};
export default handleError;
